let tidioInitialized = false;

export const initTidioChat = () => {
  if (tidioInitialized) return;

  const script = document.createElement('script');
  script.src = import.meta.env.VITE_TIDIO_SCRIPT_URL;
  script.async = true;
  
  script.onload = () => {
    tidioInitialized = true;
    // Hide default TIDIO button since we're using custom one
    if (window.tidioChatApi) {
      window.tidioChatApi.hide();
    }
  };
  
  document.body.appendChild(script);
};

export const openTidioChat = () => {
  if (window.tidioChatApi) {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }
};
